import { Avatar, AVATAR_HEIGHT_24 } from '../../../../Avatar'
import { getListingPortalLabel } from '../../../../RentalPortalListing'
import { TableCellBase, TableCellText } from '../../../../Table'
import { getPortalAvatarProps } from '../../../RentalPortal.utils'

import * as styles from './IntegrationsBrandCell.module.css'

function IntegrationsBrandCell({ connection, ...cellProps }) {
  return (
    <TableCellBase {...cellProps}>
      <Avatar
        {...getPortalAvatarProps(connection.portal)}
        className={styles.logo}
        size={AVATAR_HEIGHT_24}
      />
      <TableCellText value={getListingPortalLabel(connection.portal)} />
    </TableCellBase>
  )
}

export default IntegrationsBrandCell
